import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const NeatGlass = ({ value, onChange, id='NeatGlass', label = 'Neat Glass', disabled = false, showPics = false }) => {
    const [selectedNeatGlass, setSelectedNeatGlass] = useState(value || "No");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setSelectedNeatGlass(value || "No");
    }, [value]);

    const handleNeatGlassChange = (e) => {
        setSelectedNeatGlass(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
                {showPics && (
                    <span
                        onClick={() => setShowModal(true)}
                        style={{
                            display: 'inline-block',
                            marginLeft: '6px',
                            width: '16px',
                            height: '16px',
                            borderRadius: '50%',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            textAlign: 'center',
                            lineHeight: '16px',
                            fontSize: '12px',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }}
                        title="Click to view image"
                    >
                        i
                    </span>
                )}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedNeatGlass}
                onChange={handleNeatGlassChange}
            >
                {/*<option value="" disabled hidden>Select an option</option>*/}
                <option value="No">{selectedNeatGlass === "No" ? "No ✔" : "No"}</option>
                <option value="Yes">{selectedNeatGlass === "Yes" ? "Yes ✔" : "Yes"}</option>
            </select>
            <ImageModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                folder="images/NeatGlass"
                imageName={selectedNeatGlass}
                width={200}  //optional               
                height={250} //optional
            />
        </div>
    );
};

export default NeatGlass;
